import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import UserServices from "../services/externalServices/userServices";
import Rating from "@mui/material/Rating";
import moment from "moment";
import {
  Typography,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";

function Users() {
  const [userData, setUserData] = useState([]);
  const [followupData, setFollowupData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // State for dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [followUpData, setFollowUpData] = useState({
    name: "",
    location: "",
    comments: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Use ref to store follow-up value
  const followUpRef = useRef("");

  const fetchUserData = async () => {
    try {
      const response = await UserServices.getAllUsers();
      setUserData(response);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // const fetchFollowupData = async () => {
  //   try {
  //     // Replace with your actual API call for fetching follow-up data
  //     const response = await UserServices.getFollowUp();

  //     if (response && Array.isArray(response.followUps)) {
  //       // Assuming 'followUps' is an array of follow-up objects
  //       console.log("response in followup", response.followUps);
  //       const followupMap = response.followUps.reduce((acc, followup) => {
  //         const userId = followup.userId._id;

  //       // Store the full details (name, location, comments) for each user
  //       acc[userId] = followup.details || { name: "", location: "", comments: "" };
  //       }, {});
  //       console.log("response in followup", followupMap);
  //       setFollowupData(followupMap);
  //     } else {
  //       console.error("Unexpected response format:", response);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching follow-up data:", error);
  //   }
  // };

  const fetchFollowupData = async () => {
    try {
      // Replace with your actual API call for fetching follow-up data
      const response = await UserServices.getFollowUp();

      if (response && Array.isArray(response.followUps)) {
        // Assuming 'followUps' is an array of follow-up objects
        console.log("response in followup", response.followUps);

        // Initialize 'acc' to be an empty object at the beginning
        const followupMap = response.followUps.reduce((acc, followup) => {
          const userId = followup.userId?._id;

          // Initialize the userId entry in acc if it does not exist
          acc[userId] = acc[userId] || { name: "", location: "", comments: "" };

          // Update the fields with the follow-up data
          acc[userId] = { ...acc[userId], ...followup.details };

          return acc;
        }, {}); // Initial value is an empty object

        console.log("Updated follow-up map", followupMap);

        // Update state with the full follow-up data (including name, location, comments)
        setFollowupData(followupMap);
      } else {
        console.error("Unexpected response format:", response);
      }
    } catch (error) {
      console.error("Error fetching follow-up data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchFollowupData();
  }, []);

  const handleDialogOpen = (userId, followUp) => {
    setSelectedUserId(userId);
    console.log("currentFollowUp", followUp);
    // Handle current follow-up data (if exists)
    if (followUp) {
      try {
        const parsedFollowUp = JSON.parse(followUp); // Parse as JSON
        setFollowUpData(
          parsedFollowUp.details || { name: "", location: "", comments: "" }
        );
      } catch (e) {
        setFollowUpData({
          name: followUp.name,
          location: followUp.location,
          comments: followUp.comments,
        }); // Treat as plain string
      }
    } else {
      setFollowUpData({ name: "", location: "", comments: "" });
    }

    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedUserId(null);
    followUpRef.current = ""; // Reset on close
  };

  // const handleSaveFollowUp = async () => {
  //   try {
  //     const editedFollowUp = followUpRef.current;
  //     console.log("data============",selectedUserId,editedFollowUp,)
  //     const data={internalComments:editedFollowUp}
  //     await UserServices.updateUser(selectedUserId,data);
  //     setUserData((prev) => ({
  //       ...prev,
  //       [selectedUserId]: editedFollowUp,
  //     }));
  //     handleDialogClose();
  //   } catch (error) {
  //     console.error("Error saving follow-up:", error);
  //   }
  // };

  const handleSaveFollowUp = async () => {
    // Prepare the data for saving
    try {
      const updatedFollowUp = {
        userId: selectedUserId,
        details: followUpData,
      };

      // You can save the updated follow-up via API here
      console.log("Saving follow-up:", updatedFollowUp);
      await UserServices.updateFollowUp(updatedFollowUp);

      setUserData((prevUserData) =>
        prevUserData.map((user) =>
          user._id === selectedUserId
            ? {
                ...user,
                followUp: followUpData, // Update the follow-up data for the specific user
              }
            : user
        )
      );

      setFollowupData((prevFollowupData) => ({
        ...prevFollowupData,
        [selectedUserId]: followUpData,
      }));
      // Trigger Snackbar with success message
      setSnackbarMessage("Follow-up added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Close the dialog after saving
      handleDialogClose();
    } catch (error) {
      // setSnackbarMessage("");
      setSnackbarMessage("Error updating follow-up. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      console.log("Error updating user follow up", error);
    }
  };

  const handleInputChange = (field, event) => {
    setFollowUpData((prevData) => ({
      ...prevData,
      [field]: event.target.value,
    }));
  };

  const filteredUsers = userData
    .filter((user) => {
      const query = searchQuery.toLowerCase();

      // Check conditions for each field, safely handling undefined/null values
      const matchesFirstName = user?.first_name?.toLowerCase().includes(query);
      const matchesLastName = user?.last_name?.toLowerCase().includes(query);
      const matchesPhoneNumber = user?.phone_number
        ?.toString()
        .includes(searchQuery);
      const matchesEmail = user?.email_id?.toLowerCase().includes(query);

      // console.log("matchesPhoneNumber",matchesPhoneNumber)
      // Return true if any condition matches
      return (
        matchesFirstName ||
        matchesLastName ||
        matchesPhoneNumber ||
        matchesEmail
      );
    })
    .sort((a, b) => {
      // Sort by 'created_at' date in descending order (most recent first)
      return new Date(b.created_at) - new Date(a.created_at);
    });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
    setPage(0);
  };

  const columns = [
    { field: "id", headerName: "Slno", width: 80 },
    {
      field: "created_at",
      headerName: "Join Date",
      width: 130,
      renderCell: (params) => (
        // <Typography variant="body2">
        <>{params.value ? moment(params.value).format("YYYY-MM-DD") : "N/A"}</>
      ),
    },
    {
      field: "first_name",
      headerName: "Name",
      width: 150,
      renderCell: (params) => (
        // <Link
        //   to={{ pathname: `/users/${params.row._id}` }}
        //   className="text-decoration-none text-dark font-weight-bold"
        // >
        <>{`${params.row.first_name} ${params.row.last_name}`}</>
        // </Link>
      ),
    },
    {
      field: "countryCode",
      headerName: "Country code",
      width: 100,
    },
    {
      field: "phone_number",
      headerName: "Phone Number",
      width: 150,
      renderCell: (params) => (
        <Link
          to={{ pathname: `/users/${params.row._id}` }}
          className="text-decoration-none text-dark font-weight-bold"
        >
          {`${params.row.phone_number}`}
        </Link>
      ),
    },
    { field: "lastAccessed", headerName: "Last Accessed", width: 150,
      renderCell: (params) => {
        const dateStr = params.value;
  
        // ✅ Check if date is in ISO format or custom format
        const isISO = moment(dateStr, moment.ISO_8601, true).isValid();
        const isCustomFormat = moment(dateStr, "DD-MM-YYYY HH:mm", true).isValid();
  
        // ✅ Format to "DD-MM-YYYY HH:mm" regardless of input format
        const formattedDate = isISO
          ? moment(dateStr).format("DD-MM-YYYY HH:mm")
          : isCustomFormat
          ? moment(dateStr, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")
          : "Invalid Date";
  
        return <>{formattedDate}</>;
      },
     },
    {
      field: "followUp", // Field for displaying follow-up comments
      headerName: "Follow-Up",
      width: 250,
      renderCell: (params) => {
        const userId = params.row._id;
        // console.log("followupData[userId]", followupData[userId]);
        const currentFollowUp = followupData[userId]?.comments || "";

        return (
          <Tooltip title="Click to add/edit follow-up">
            <Typography
              onClick={() => handleDialogOpen(userId, followupData[userId])}
              sx={{
                textDecoration: currentFollowUp ? "none" : "underline",
                color: currentFollowUp ? "inherit" : "blue",
                cursor: "pointer",
                mt: 2,
                whiteSpace: "normal",
                wordWrap: "break-word",
                maxHeight: "100px",
                overflow: "hidden",
              }}
            >
              {currentFollowUp || "Add Follow-Up"}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "rating",
      headerName: "Rating",
      width: 150,
      renderCell: (params) => (
        <Rating name="read-only" value={params.value} readOnly />
      ),
    },
    { field: "otpMode", headerName: "Otp Mode", width: 120 },
    { field: "email_id", headerName: "Email-Id", width: 200 },
    {
      field: "emergency_contact",
      headerName: "Emergency Contact Number",
      width: 220,
    },
  ];

  const rows = filteredUsers.map((user, index) => ({
    id: index + 1,
    ...user,
  }));

  return (
    <div className="container mt-1">
      <nav>
        <ol className="breadcrumb d-none d-lg-flex">
          <li className="breadcrumb-item">
            <Link
              to="/dashboard"
              className="text-decoration-none"
              style={{ color: "#41505f" }}
            >
              Home
            </Link>
          </li>
          <li className="breadcrumb-item opacity-50">Users</li>
        </ol>
      </nav>
      <div className="col-md-auto mt-2">
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <SearchIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
          <TextField
            label="Search User"
            variant="standard"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Box>
      </div>
      <Paper sx={{ height: 440, width: "100%", marginTop: "20px" }}>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          page={page}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          rowCount={filteredUsers.length}
          pagination
        />
      </Paper>
      {/* Dialog for Follow-Up */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        sx={{ minWidth: 600 }}
      >
        <DialogTitle>Edit Follow-Up</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Name"
            value={followUpData.name}
            onChange={(e) => handleInputChange("name", e)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Location"
            value={followUpData.location}
            onChange={(e) => handleInputChange("location", e)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Comments"
            multiline
            rows={3}
            value={followUpData.comments}
            onChange={(e) => handleInputChange("comments", e)}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleSaveFollowUp}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Users;
